module.exports = __webpack_public_path__ + "static/media/logo-white.4e021e0b.svg";